/**
 * Utility to clear stuck authentication cache
 * Run this in browser console if you get stuck with OAuth errors
 */
export const clearAuthCache = () => {
  // Clear all Supabase auth related items from localStorage
  const keysToRemove: string[] = [];
  
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && (
      key.includes('supabase.auth') ||
      key.includes('sb-') ||
      key.includes('spotify')
    )) {
      keysToRemove.push(key);
    }
  }
  
  keysToRemove.forEach(key => {
    console.log(`Removing: ${key}`);
    localStorage.removeItem(key);
  });
  
  // Clear session storage too
  sessionStorage.clear();
  
  // Clear cookies related to Supabase
  document.cookie.split(";").forEach((c) => {
    document.cookie = c
      .replace(/^ +/, "")
      .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
  });
  
  console.log('Auth cache cleared. Please refresh the page.');
  
  return keysToRemove.length;
};

// Add to window for easy console access
if (typeof window !== 'undefined') {
  (window as any).clearAuthCache = clearAuthCache;
}